let votesStore = {};

export const updateVotesStore = (updatedVotes: any) => {
    votesStore = {...votesStore, ...updatedVotes};
}

export const getVotesCategoryStore: any = (category: number) => {
    // @ts-ignore
    return votesStore[category];
}